import { z } from 'zod';
/** Background-observed outcome status for a brief item. */
export const BriefOutcomeStatus = z.enum([
    'pending', // No signal yet
    'confirmed', // The agent's prediction matched reality (e.g., Acme renewed)
    'partial', // Partially matched
    'refuted', // The prediction was wrong
    'lapsed', // No signal in the observation window — treat as no-op
]);
/**
 * Background-observed outcome for a brief item, written by the agent
 * between 1-4 weeks after item disposition. Lives in `briefOutcomes/{outcomeId}`
 * with `brief_id + item_id` references so the Outcomes tab can render
 * "what happened next" per item.
 */
export const BriefOutcome = z.object({
    id: z.string(),
    orgId: z.string(),
    brief_id: z.string(),
    item_id: z.string(),
    status: BriefOutcomeStatus,
    observed_at: z.string().datetime(),
    /** Evidence ids from the target system audit (e.g. 'sf_2114', 'gmail_8821'). */
    evidence_ids: z.array(z.string()).default([]),
    /** Human-readable summary of what was observed. */
    summary: z.string().max(500).optional(),
});
